import axios from 'axios';
import * as cookies from './cookies';

export const guid = cookies.get('IDR_GUID');

export function playWaw(name, location) {
  if (!guid) return;

  axios.post('/api/idr/sendWebRequest', {
    requestId: guid,
    commandType: 'PlayWav',
    pageId: name,
  }).then(() => {
    if (location) window.location.href = location;
  }).catch((error) => console.warn(error));
}

export function returnToOperator() {
  if (!guid) return;

  axios.post('/api/idr/sendWebRequest', {
    requestId: guid,
    commandType: 'ReturnToVoiceDisconnected',
    pageId: 'Digitl_operator',
  }).then(() => {
    window.location.href = '/logout/';
  }).catch((error) => console.warn(error));
}

export function returnToVoice() {
  if (!guid) return;

  let pageId = 'Digitl_glavnoe_menu';
  const { pathname } = window.location;
  if (~pathname.indexOf('services')) pageId = 'm0611_prepaid_high_22k';
  if (~pathname.indexOf('last-payments')) pageId = 'm0611_prepaid_high_21k';
  if (~pathname.indexOf('last-expenses')) pageId = 'm0611_prepaid_high_232k';

  axios.post('/api/idr/sendWebRequest', {
    requestId: guid,
    commandType: 'ReturnToVoiceDisconnected',
    pageId,
  }).then(() => {
    window.location.href = '/logout/';
  }).catch((error) => console.warn(error));
}

export function exit() {
  if (!guid) return;

  axios.post('/api/idr/sendWebRequest', {
    requestId: guid,
    commandType: 'Exit',
  }).then(() => {
    window.location.href = '/logout/';
  }).catch((error) => console.warn(error));
}
